import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CrossStudyComponent } from './cross-study.component';

const routes: Routes = [
  {path: ':lang/ristiinopiskelu/:id', pathMatch: 'full', component: CrossStudyComponent},
  {path: ':lang/cross-institutional-studies/:id', pathMatch: 'full', component: CrossStudyComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CrossStudyRoutingModule { }
